import { Button } from '@/components/ui/common/Button'
import { CheckCircle, XCircle } from 'lucide-react'
import React from 'react'
import { SquareTask } from './TaskScreen'

interface ResultScreenProps {
  currentTask: SquareTask
  isCorrect: boolean
  placedFragmentId: string | null
  onNext: () => void
  isLastTask: boolean
  onStart?: () => void
  onComplete?: () => void
}

export function ResultScreen({
  currentTask,
  isCorrect,
  placedFragmentId,
  onNext,
  isLastTask,
  onStart,
  onComplete
}: ResultScreenProps) {
  React.useEffect(() => {
    if (onStart) {
      onStart()
    }
  }, [onStart])

  const handleNext = () => {
    if (isLastTask && onComplete) {
      onComplete()
    }
    onNext()
  }

  const correctFragment = currentTask.fragments.find((fragment) => fragment.isCorrect)
  const selectedFragment = placedFragmentId
    ? currentTask.fragments.find((fragment) => fragment.id === placedFragmentId)
    : null

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex items-center gap-2">
        {isCorrect ? (
          <CheckCircle className="h-8 w-8 text-green-500" />
        ) : (
          <XCircle className="h-8 w-8 text-red-500" />
        )}
        <h2 className="text-xl font-bold">{isCorrect ? 'Poprawnie!' : 'Niepoprawnie'}</h2>
      </div>

      <p className="text-center">
        {isCorrect
          ? 'Świetnie! Wybrałeś właściwy fragment.'
          : 'Niestety, to nie jest właściwy fragment. Spróbuj jeszcze raz.'}
      </p>

      <Button
        className=" text-white bg-[#2bcaca] hover:bg-[#2b9999]"
        onClick={handleNext}
      >
        {isLastTask ? 'Zakończ' : 'Następne zadanie'}
      </Button>

      <div className="w-full max-w-md">
        <div className="grid grid-cols-2 gap-6">
          <div>
            <h3 className="mb-2 text-center text-sm font-medium">Poprawny fragment:</h3>
            <div className="rounded-md border p-2">
              <div
                className="rounded"
                style={{
                  width: '100%',
                  height: '100px',
                  backgroundImage: `url(${currentTask.imageUrl})`,
                  backgroundSize: `${600}px ${400}px`,
                  backgroundPosition: `-${correctFragment?.sourceCoords.x}px -${correctFragment?.sourceCoords.y}px`
                }}
              />
            </div>
          </div>

          {placedFragmentId && (
            <div>
              <h3 className="mb-2 text-center text-sm font-medium">Twój wybór:</h3>
              <div className="rounded-md border p-2">
                <div
                  className="rounded"
                  style={{
                    width: '100%',
                    height: '100px',
                    backgroundImage: `url(${currentTask.imageUrl})`,
                    backgroundSize: `${600}px ${400}px`,
                    backgroundPosition: `-${selectedFragment?.sourceCoords.x}px -${selectedFragment?.sourceCoords.y}px`
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="w-full max-w-md">
        <div
          className="relative overflow-hidden rounded-md border"
          style={{ minHeight: '300px' }}
        >
          <img
            alt="Complete image"
            className="h-full w-full object-contain"
            src={currentTask.imageUrl || '/placeholder.svg'}
          />
        </div>
      </div>
    </div>
  )
}
